/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_Submit_AssignmentInputs */



/**
* | output |
* | --- |
* | "Record assignment" |
*
* @param {Promo_Movement_Submit_AssignmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_submit_assignment = /** @type {((inputs?: Promo_Movement_Submit_AssignmentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Submit_AssignmentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer l'attribution")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar asignación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrar atribuição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra l'assegnazione")
	return /** @type {LocalizedString} */ ("Record assignment")
});